export enum ReportsLayoutType {
    TABLE = 'table',
    LINE_CHART = 'line',
    BAR_CHART = 'bar',
}

export const ReportsLayoutIconName = {
    [ReportsLayoutType.TABLE]: 'table',
    [ReportsLayoutType.LINE_CHART]: 'line-chart',
    [ReportsLayoutType.BAR_CHART]: 'bar-chart'
};

export interface ReportsLayout {
    iconName: string;
    label: string;
    id: ReportsLayoutType;
}
